import { type ComponentType } from 'react';
import { Landing } from './pages/Landing';
export type DeckSlide = {
  id: string;
  title: string;
  component: ComponentType;
};
export const slides: DeckSlide[] = [{
  id: 'scr_g094e2',
  title: 'Landing VCARS',
  component: Landing
}];